import { useFormContext } from 'react-hook-form';
import { Button, type ButtonProps } from '../ui/Button';

interface SubmitInputProps extends ButtonProps {
    isLoading: boolean;
    variant: 'success' | 'danger' | 'warning' | 'light';
    disabled: boolean;
    once?: boolean;
}

export const SubmitInput = ({
    isLoading = false,
    once = false,
    children,
    disabled,
    ...props
}: Partial<SubmitInputProps>) => {
    const { formState } = useFormContext();

    return (
        <Button
            type="submit"
            disabled={isLoading || disabled || (once ? formState.isSubmitSuccessful : false)}
            isLoading={isLoading}
            {...props}
        >
            {isLoading ? (
                <>
                    <span className="tw-spinner-border tw-spinner-border-sm tw-mr-2" role="status" aria-hidden="true" />
                    <span>Lade...</span>
                </>
            ) : (
                children
            )}
        </Button>
    );
};
